import { Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { graduationRequests } from "api/graduationApi";
import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { FunctionField, Labeled, ReferenceField, Show, SimpleShowLayout, TextField } from "react-admin";
import { InternshipSessionField } from "server/components/Fields/InternshipSessionInput";
import RoomField from "server/components/Fields/RoomField";
import { SectionTitle } from "features/SectionTitle";

const ShowScheduleFreeSelectionSlot = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли на свободен избор разписание"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Сесиен стаж">
              <InternshipSessionField />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Стажантски план">
              <ReferenceField
                source="planId"
                reference={graduationRequests.getInternshipPlansSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Дисциплина">
              <ReferenceField
                source="disciplineId"
                reference={administrationRequests.getDisciplinesSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Зала">
              <RoomField />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Капацитет">
              <TextField source="studentsCapacity" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Час">
              <FunctionField render={rec => `${rec?.fromTime} - ${rec?.toTime}`} />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowScheduleFreeSelectionSlot;
